import { Button, Modal, Table } from "@arco-design/web-react";
import { useCallback, useEffect, useState } from "react"
import { Number } from "@/components/Numeric";
import { EnumLabel } from "@/components/Enum";
import { GLActionDef } from "@/enums/common";
import { GLAPI } from "@/apis/accounting";

const GLImpactButton = ({ type, from, ...props }) => {
    const [visible, setVisible] = useState(false);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getGLList = useCallback(async () => {
        const values = await GLAPI.query(page, type, from);
        setData(values.records);
        setTotal(values.total);
    }, [page, type, from]);

    useEffect(() => {
        if (visible) getGLList();
    }, [getGLList, visible])

    return (
        <>
            <Button type="primary" {...props} onClick={() => setVisible(true)}>GL Impact</Button>
            <Modal title="GL Impact"
                style={{ width: 800 }}
                visible={visible}
                footer={
                    <Button onClick={() => setVisible(false)}>Close</Button>
                }
                onCancel={() => setVisible(false)}
            >
                <Table rowKey="id"
                    columns={[
                        { title: "Account", dataIndex: "accountName" },
                        { title: "Action", render: (col, record) => <EnumLabel enumObj={GLActionDef} value={record.action} /> },
                        { title: "Amount", render: (col, record) => <span>{record.itemName}: <Number value={Math.abs(record.totalAmount)} /></span> },
                        { title: "Create Time", dataIndex: "impactDate" }
                    ]}
                    data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)}
                />
            </Modal>
        </>
    )
}

export default GLImpactButton;
